import { useState } from "react";
import { apiFetch } from "../services/api.js";
import { getUser } from "../services/auth.js";

export default function TabelaSorteios({ anuais, onRefresh }) {
  const [editando, setEditando] = useState(null);
  const [dados, setDados] = useState({});
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [showArchived, setShowArchived] = useState(false);

  function abrirEdicao(anual) {
    setEditando(anual.id);
    setDados({
      nome: anual.nome,
      quantidade_premios: anual.quantidade_premios,
      ativo: anual.ativo,
    });
    setErro("");
    setSucesso("");
  }

  function cancelarEdicao() {
    setEditando(null);
    setDados({});
  }

  async function salvarEdicao(anualId) {
    setSalvando(true);
    setErro("");
    setSucesso("");

    try {
      await apiFetch(`anuais/${anualId}`, {
        method: "PUT",
        body: JSON.stringify({
          nome: dados.nome,
          quantidade_premios: Number(dados.quantidade_premios),
          ativo: dados.ativo,
        }),
      });

      setSucesso("Sorteio anual atualizado com sucesso!");
      setEditando(null);
      onRefresh && onRefresh();

      setTimeout(() => setSucesso(""), 3000);
    } catch (err) {
      console.error("[ERRO TABELA ANUAIS]", err);
      setErro(err.message || "Erro ao atualizar sorteio");
    } finally {
      setSalvando(false);
    }
  }

  async function handleDeletar(anualId) {
    if (!window.confirm("Tem certeza que deseja excluir este sorteio anual?"))
      return;
    try {
      await apiFetch(`anuais/${anualId}`, { method: "DELETE" });
      console.log("[TABELA ANUAIS] Deletado ID: " + anualId);
      onRefresh && onRefresh();
    } catch (err) {
      console.error("[ERRO DELETE ANUAL]", err);
      setErro(err.message || "Erro ao excluir sorteio");
    }
  }

  async function toggleArquivar(anual) {
    try {
      await apiFetch(`anuais/${anual.id}`, {
        method: "PUT",
        body: JSON.stringify({
          nome: anual.nome,
          quantidade_premios: anual.quantidade_premios,
          ativo: anual.ativo,
          arquivado: !anual.arquivado,
        }),
      });
      onRefresh && onRefresh();
    } catch (err) {
      setErro(err.message || "Erro ao arquivar sorteio");
    }
  }

  function formatarData(data) {
    if (!data) return "-";
    const d = new Date(data);
    return d.toLocaleDateString("pt-BR");
  }

  if (!anuais || anuais.length === 0) {
    return <p style={{ color: "#999" }}>Nenhum sorteio anual cadastrado</p>;
  }

  return (
    <div>
      <div>
        <h4>Sorteios Anuais Ativos</h4>
        {anuais.filter((a) => !a.arquivado).length === 0 ? (
          <p style={{ color: "#999" }}>Nenhum sorteio ativo</p>
        ) : (
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr
                style={{
                  backgroundColor: "#f0f0f0",
                  borderBottom: "2px solid #ddd",
                }}
              >
                <th style={{ padding: "1rem", textAlign: "left" }}>Nome</th>
                <th style={{ padding: "1rem", textAlign: "left" }}>Código</th>
                <th style={{ padding: "1rem", textAlign: "left" }}>Prêmios</th>
                <th style={{ padding: "1rem", textAlign: "left" }}>Criado</th>
                <th style={{ padding: "1rem", textAlign: "left" }}>Sorteado</th>
                <th style={{ padding: "1rem", textAlign: "left" }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {anuais
                .filter((a) => !a.arquivado)
                .map((anual) =>
                  editando === anual.id ? (
                    <tr
                      key={anual.id}
                      style={{
                        backgroundColor: "#f8f9fa",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      <td style={{ padding: "1rem" }}>
                        <input
                          type="text"
                          value={dados.nome}
                          onChange={(e) =>
                            setDados({ ...dados, nome: e.target.value })
                          }
                          style={{
                            width: "100%",
                            padding: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                          }}
                        />
                      </td>
                      <td style={{ padding: "1rem" }}>-</td>
                      <td style={{ padding: "1rem" }}>
                        <input
                          type="number"
                          min="1"
                          value={dados.quantidade_premios}
                          onChange={(e) =>
                            setDados({
                              ...dados,
                              quantidade_premios: e.target.value,
                            })
                          }
                          style={{
                            width: "100%",
                            padding: "0.5rem",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                          }}
                        />
                      </td>
                      <td colSpan="3" style={{ padding: "1rem" }}>
                        <button
                          onClick={() => salvarEdicao(anual.id)}
                          disabled={salvando}
                          style={{
                            backgroundColor: "#667eea",
                            color: "white",
                            border: "none",
                            padding: "0.4rem 0.8rem",
                            borderRadius: "4px",
                            cursor: salvando ? "not-allowed" : "pointer",
                            marginRight: "0.5rem",
                          }}
                        >
                          {salvando ? "Salvando..." : "Salvar"}
                        </button>
                        <button
                          onClick={cancelarEdicao}
                          disabled={salvando}
                          style={{
                            backgroundColor: "#e74c3c",
                            color: "white",
                            border: "none",
                            padding: "0.4rem 0.8rem",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Cancelar
                        </button>
                      </td>
                    </tr>
                  ) : (
                    <tr
                      key={anual.id}
                      style={{ borderBottom: "1px solid #ddd" }}
                    >
                      <td style={{ padding: "1rem" }}>{anual.nome}</td>
                      <td style={{ padding: "1rem" }}>
                        <strong>{anual.codigo}</strong>
                      </td>
                      <td style={{ padding: "1rem" }}>
                        {anual.quantidade_premios}
                      </td>
                      <td style={{ padding: "1rem", fontSize: "0.9rem" }}>
                        {formatarData(anual.data_inicio)}
                      </td>
                      <td style={{ padding: "1rem", fontSize: "0.9rem" }}>
                        {formatarData(anual.data_fim)}
                      </td>
                      <td style={{ padding: "1rem" }}>
                        <button
                          onClick={() => abrirEdicao(anual)}
                          style={{
                            backgroundColor: "#667eea",
                            color: "white",
                            border: "none",
                            padding: "0.4rem 0.8rem",
                            borderRadius: "4px",
                            cursor: "pointer",
                            marginRight: "0.5rem",
                            fontSize: "0.9rem",
                          }}
                        >
                          Editar
                        </button>
                        {getUser()?.role === "admin" && (
                          <>
                            <button
                              onClick={() => toggleArquivar(anual)}
                              style={{
                                backgroundColor: "#34495e",
                                color: "white",
                                border: "none",
                                padding: "0.4rem 0.8rem",
                                borderRadius: "4px",
                                cursor: "pointer",
                                marginRight: "0.5rem",
                                fontSize: "0.9rem",
                              }}
                            >
                              Arquivar
                            </button>
                            <button
                              onClick={() => handleDeletar(anual.id)}
                              style={{
                                backgroundColor: "#e74c3c",
                                color: "white",
                                border: "none",
                                padding: "0.4rem 0.8rem",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontSize: "0.9rem",
                              }}
                            >
                              Excluir
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ),
                )}
            </tbody>
          </table>
        )}

        {/* Painel de Arquivados */}
        {anuais.filter((a) => a.arquivado).length > 0 && (
          <div style={{ marginTop: "2rem" }}>
            <button
              onClick={() => setShowArchived((v) => !v)}
              style={{ padding: "0.4rem 0.6rem" }}
            >
              {showArchived ? "Ocultar Arquivados" : "Mostrar Arquivados"}
            </button>
            {showArchived && (
              <div
                style={{
                  marginTop: "1rem",
                  border: "1px solid #ddd",
                  padding: "1rem",
                  borderRadius: "4px",
                }}
              >
                <h5>Sorteios Anuais Arquivados</h5>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th style={{ padding: "0.5rem", textAlign: "left" }}>
                        Nome
                      </th>
                      <th style={{ padding: "0.5rem", textAlign: "left" }}>
                        Código
                      </th>
                      <th style={{ padding: "0.5rem", textAlign: "left" }}>
                        Criado
                      </th>
                      <th style={{ padding: "0.5rem", textAlign: "left" }}>
                        Sorteado
                      </th>
                      <th style={{ padding: "0.5rem", textAlign: "left" }}>
                        Ações
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {anuais
                      .filter((a) => a.arquivado)
                      .map((anual) => (
                        <tr key={anual.id}>
                          <td style={{ padding: "0.5rem" }}>{anual.nome}</td>
                          <td style={{ padding: "0.5rem" }}>{anual.codigo}</td>
                          <td style={{ padding: "0.5rem", fontSize: "0.9rem" }}>
                            {formatarData(anual.data_inicio)}
                          </td>
                          <td style={{ padding: "0.5rem", fontSize: "0.9rem" }}>
                            {formatarData(anual.data_fim)}
                          </td>
                          <td style={{ padding: "0.5rem" }}>
                            <button
                              onClick={async () => {
                                if (!window.confirm("Restaurar sorteio?"))
                                  return;
                                try {
                                  await apiFetch(`anuais/${anual.id}`, {
                                    method: "PUT",
                                    body: JSON.stringify({
                                      nome: anual.nome,
                                      quantidade_premios:
                                        anual.quantidade_premios,
                                      ativo: anual.ativo,
                                      arquivado: false,
                                    }),
                                  });
                                  onRefresh && onRefresh();
                                } catch (err) {
                                  alert("Erro: " + err.message);
                                }
                              }}
                              style={{
                                padding: "0.4rem 0.6rem",
                                fontSize: "0.9rem",
                                backgroundColor: "#27ae60",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                            >
                              Restaurar
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </div>

      {erro && (
        <p style={{ color: "#e74c3c", fontWeight: "600", marginTop: "1rem" }}>
          {erro}
        </p>
      )}
      {sucesso && (
        <p
          style={{
            color: "#27ae60",
            fontWeight: "600",
            marginTop: "1rem",
          }}
        >
          {sucesso}
        </p>
      )}
    </div>
  );
}
